import Profile from './PortfolioContainer/Home/Profile'
import Menu from './PortfolioContainer/MenuBar/Menu';
import ContactMe from './PortfolioContainer/ContactMe/ContactMe';
import AboutMe from './PortfolioContainer/AboutMe/AboutMe';
import './App.css';
import Footer from './PortfolioContainer/Footer/Footer';
import Skill from './PortfolioContainer/Skill/Skill';
import Protfilio from './PortfolioContainer/Portfilio/Protfilio';


function App() {
  return (

    <>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Md Nazmul Hossain - Frontend Developer Portfolio | React.js Specialist</title>
        <meta name="description" content="Explore the portfolio of Md Nazmul Hossain, a skilled frontend developer specializing in React.js with 1.4 years of experience. Contact Md Nazmul Hossain for frontend development solutions." />
      </head>
      <div className="App">

        <Menu />
        <Profile />
        <AboutMe />
        <Skill />
        <Protfilio />
        <ContactMe />
        <Footer />
      </div>
    </>

  );
}

export default App;
